var app = angular.module('leonardo');

var PropertyListFilter = function () {
  return function (account) {
    if (!account || account.length === 0) {
      return;
    }
    if (account.is_owner) {
      return 'All properties';
    }
    if (!account.properties || account.properties.length === 0) {
      return '-';
    }
    if (account.properties.length > 3) {
      return account.properties.length + ' properties';
    }
    var names = [];
    angular.forEach(account.properties, function(item) {
      names.push(item.name);
    });
    names.sort();
    return names.join(', ');
  };
};

app.filter('propertyList', [PropertyListFilter]);
